import SupportContacts from '../components/SupportContacts';

/**
 * A rider's help (`/driver/chat`), on InGo (Rio, 2 Oct 2026: support chat
 * becomes contact buttons): the office's numbers from Settings, the same the
 * clients see. The old system's chat ran on its own database.
 */
export default function DriverSupportChatPage() {
  return <SupportContacts back="/driver/profile" note="On a job, the client's number is on the job's screen." />;
}
